var $7ceabaf205d867a4$exports = {};
$7ceabaf205d867a4$exports = {
    "collectionLabel": `Ehdotukset`
};


export {$7ceabaf205d867a4$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
